import { cn } from "@/lib/utils";

import { useConfigurationContext } from "../root/ConfigurationContext";

/**
 * Renders a note-status dot always paired with its text label (never color
 * alone, design-system.md section 3 "semáforo ... nunca color solo").
 *
 * `labelClassName` styles the label span only. It defaults to no forced
 * size, so the label inherits the ambient text size of the surrounding
 * control (e.g. a filter toggle, >= 15px). Pass a smaller size explicitly
 * (e.g. `text-[12.5px]`, the design system's label floor) at call sites
 * where Status is secondary metadata next to larger body text.
 */
export const Status = ({
  status,
  className,
  labelClassName,
}: {
  status?: string | null;
  className?: string;
  labelClassName?: string;
}) => {
  const { noteStatuses } = useConfigurationContext();
  if (!status || !noteStatuses) return null;
  const statusObject = noteStatuses.find((s: any) => s.value === status);

  if (!statusObject) return null;
  return (
    <span className={cn("inline-flex items-center gap-1.5", className)}>
      <span
        aria-hidden="true"
        className="inline-block size-2.5 rounded-full shrink-0"
        style={{ backgroundColor: statusObject.color }}
      />
      <span className={labelClassName}>{statusObject.label}</span>
    </span>
  );
};
